import { arraySum } from "./arraySum";
export const arrayAvg = (values) => arraySum(values) / (values.length || 1);
